import React from 'react';
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import pluralize from 'pluralize';
import PropTypes from 'prop-types';
import verified from '../images/verified-blue.svg';


export default class BeingTackedBy extends React.Component {
  static propTypes = {
    tackedBy: PropTypes.object,
    tacksCount: PropTypes.number,
  }

  render() {
    const publicPeopleList = [];
    this.props.tackedBy && this.props.tackedBy.map((userMeta, i) => {
      publicPeopleList.unshift(
        <Link key={i} to={ `/people/${userMeta.get('slug')}` } className='link-with-no-border'>
          { this.tackedbyDisplayName(userMeta) }
        </Link>
      )
    });
    const others = this.others();
    others && publicPeopleList.push(others);
    const beingTackedBy = this.toSentence(publicPeopleList);
    return (
      <Fragment>
        Tacked by { beingTackedBy }.
      </Fragment>
    );
  }

  others() {
    const tacksCount = this.props.tacksCount || 0;
    const tackedByCount = (this.props.tackedBy) ? this.props.tackedBy.size : 0;
    const othersCount = tacksCount - tackedByCount;

    if ((othersCount === 0) && (tackedByCount === 0)) {
      return 'no one yet'
    } else if (othersCount > 0) {
      if (tackedByCount > 0) {
        return pluralize('other person', othersCount, true);
      } else {
        return pluralize('person', othersCount, true);
      }
    } else {
      return null;
    }
  }

  toSentence(terms) {
    const updatedTerms = [];
    terms.map((term, i) => {
      if (i === 0) {
        updatedTerms.push(term);
      } else if (i < terms.length - 1) {
        updatedTerms.push(', ');
        updatedTerms.push(term);
      } else {
        updatedTerms.push(' and ');
        updatedTerms.push(term);
      }
    });
    return updatedTerms;
  }

  tackedbyDisplayName(userMetadata) {
    if (userMetadata.get('has_active_subscription')) {
      return (
        <Fragment>
          <b>{ userMetadata.get('slug') }</b>
          <span className='verified-mark-15-inline'>
            <img src={verified} alt='Verified and Unlimited' />
          </span>
        </Fragment>
      )
    } else {
      return (
        <Fragment>
          <b>{ userMetadata.get('slug') }</b>
        </Fragment>
      )
    }
  }  
}



// WEBPACK FOOTER //
// ./src/components/being_tacked_by.jsx